module.exports = __webpack_public_path__ + "img/checkbox-example.a8696efe.svg";